/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Return_RedeliverInputs */

const vi_carrier_return_redeliver = /** @type {(inputs: Carrier_Return_RedeliverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yêu cầu phát lại`)
};

/**

* @param {Carrier_Return_RedeliverInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_return_redeliver = /** @type {((inputs?: Carrier_Return_RedeliverInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Return_RedeliverInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_return_redeliver(inputs)
});